// Периодический опрос, который не работает в скрытой вкладке: забытые вкладки
// и киоски без этого гоняют запросы круглые сутки. При возврате во вкладку
// опрос выполняется сразу, если с прошлого вызова прошло не меньше интервала.
export function startVisiblePoll(fn: () => void, intervalMs: number): () => void {
  let last = Date.now();
  const run = () => {
    last = Date.now();
    fn();
  };
  const timer = setInterval(() => {
    if (document.visibilityState === "visible") run();
  }, intervalMs);
  const onVisibility = () => {
    if (document.visibilityState === "visible" && Date.now() - last >= intervalMs) run();
  };
  document.addEventListener("visibilitychange", onVisibility);
  return () => {
    clearInterval(timer);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}
